import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { WorkoutActions } from "./WorkoutActions";
import { Badge } from "@/components/ui/badge";
import { useTranslations } from "@/hooks/useTranslations";
import { FileText } from "lucide-react"; // Changed from FilePdf to FileText
import { generateWorkoutPDF } from "./WorkoutPDF";
import { Button } from "@/components/ui/button";

interface WorkoutTableProps {
  workouts: any[];
  onToggleStatus: (workoutId: string, status: string) => void;
  onDuplicate: (workout: any) => void;
  onDelete: (workoutId: string) => void;
}

export const WorkoutTable = ({
  workouts,
  onToggleStatus,
  onDuplicate,
  onDelete,
}: WorkoutTableProps) => {
  const { t } = useTranslations("workouts");
  
  const handleDownloadPDF = async (workout: any) => {
    try {
      await generateWorkoutPDF(workout);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t("table.title")}</TableHead>
          <TableHead className="hidden sm:table-cell">{t("table.student")}</TableHead>
          <TableHead className="hidden sm:table-cell">{t("table.type")}</TableHead>
          <TableHead className="hidden sm:table-cell">{t("table.duration")}</TableHead>
          <TableHead className="text-right">{t("table.actions")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {workouts.length === 0 ? (
          <TableRow>
            <TableCell colSpan={5} className="text-center py-4">
              <p className="text-muted-foreground">{t("table.noWorkoutsFound")}</p>
            </TableCell>
          </TableRow>
        ) : (
          workouts.map((workout) => (
            <TableRow key={workout.id} className="hover:bg-slate-50/50 dark:hover:bg-gray-800/50">
              <TableCell className="font-medium">
                <div className="flex items-center gap-2">
                  {workout.title}
                </div>
              </TableCell>
              <TableCell className="hidden sm:table-cell">
                {workout.target_student ? (
                  <span className="inline-flex items-center">
                    {workout.target_student.first_name} {workout.target_student.last_name}
                  </span>
                ) : (
                  <span className="text-muted-foreground text-sm">—</span>
                )}
              </TableCell>
              <TableCell className="hidden sm:table-cell">
                {workout.type ? (
                  () => {
                    const dbValue = workout.type;
                    const lookupKey = `form.types.${dbValue.toLowerCase()}`;
                    console.log(`Workout ID: ${workout.id}, DB Type: '${dbValue}', Lookup Key: '${lookupKey}'`);
                    return (
                      <Badge variant="outline" className="bg-flame/5 dark:bg-flame/10 text-flame dark:text-flame/90 border-flame/20 dark:border-flame/30">
                        {t(lookupKey)}
                      </Badge>
                    );
                  }
                )() : (
                  <span className="text-muted-foreground text-sm">—</span>
                )}
              </TableCell>
              <TableCell className="hidden sm:table-cell">
                {workout.duration ? `${workout.duration} min` : "—"}
              </TableCell>
              <TableCell>
                <WorkoutActions
                  workout={workout}
                  onToggleStatus={onToggleStatus}
                  onDuplicate={onDuplicate}
                  onDelete={onDelete}
                  onDownloadPDF={handleDownloadPDF}
                />
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
};
